import { z } from 'zod'
import { BATH_TIME } from './petAiWall/bathTime'
import { createPetAiWallRecordSchema } from './petAiWall/petAiWall.schemas'

export const CartUpsellRecordsSchema = z.object({
  'bath-time': createPetAiWallRecordSchema(BATH_TIME),
})

export type CartUpsellRecords = z.infer<typeof CartUpsellRecordsSchema>
export type CartUpsellId = keyof CartUpsellRecords
export type CartUpsellRecord<Id extends CartUpsellId> = NonNullable<
  CartUpsellRecords[Id]
>
// Mapped per id, so code generic over a group of ids (e.g. every pet AI wall) can write a value that each id in it takes.
type CartUpsellOffers = {
  [Id in CartUpsellId]: Extract<
    CartUpsellRecord<Id>,
    { status: 'offered' }
  >['offer']
}
type CartUpsellGenerations = {
  [Id in CartUpsellId]: Extract<CartUpsellRecord<Id>, { status: 'generating' }>
}
type CartUpsellGenerationFieldsById = {
  [Id in CartUpsellId]: Omit<
    CartUpsellGenerations[Id],
    'status' | 'jobId' | 'startedAt'
  >
}
export type CartUpsellOffer<Id extends CartUpsellId> = CartUpsellOffers[Id]
export type CartUpsellGeneration<Id extends CartUpsellId> =
  CartUpsellGenerations[Id]
export type CartUpsellGenerationFields<Id extends CartUpsellId> =
  CartUpsellGenerationFieldsById[Id]
export const CART_UPSELL_IDS = CartUpsellRecordsSchema.keyof().options
